
import { Component, inject, output, signal } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslatePipe } from '@ngx-translate/core';
import { FullScreenButton } from "./full-screen-button/full-screen-button";
import { AvatarButton } from "./avatar-button/avatar-button";
import { PreferencesButton } from "./preferences-button/preferences-button";
import { HelpButton } from "./help-button/help-button";
import { ToolbarButton } from '../../models/toolbar-button.type';
import { ActivatedRoute, NavigationEnd, Router, RouterLink } from '@angular/router';
import { filter, map } from 'rxjs';
import { NotificationsButton } from "./notifications-button/notifications-button";
import { SapTokenButton } from "../sap-token-button/sap-token-button";

@Component({
  selector: 'app-toolbar',
  templateUrl: './toolbar.html',
  styleUrls: ['./toolbar.scss'],
  imports: [
    MatIconModule,
    MatToolbarModule,
    MatTooltipModule,
    MatButtonModule,
    MatCardModule,
    TranslatePipe,
    FullScreenButton,
    AvatarButton,
    PreferencesButton,
    HelpButton,
    RouterLink,
    NotificationsButton,
    SapTokenButton,
]
})
export class Toolbar {
  public readonly menuToggleEvent = output();
  public readonly clickEvent = output<ToolbarButton>();
  public readonly title = signal<string | undefined>('Prep Parts is starting...');

  private readonly router = inject(Router);
  private readonly activatedRoute = inject(ActivatedRoute);

  constructor() {

    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd),
      map(() => {
        let route = this.activatedRoute.root;
        while (route.firstChild) {
          route = route.firstChild;
        }
        return route.snapshot.title;
      })
    ).subscribe(title => this.title.set(title));

  }


  menuClick(): void {
    this.menuToggleEvent.emit();
  }
}
